export default {
    name: 'topBar',
    data() {
        return {
            drawer: false,
            items: [
                { icon: 'home', title: 'About', page: '/' },
                { icon: 'subject', title: 'Blog', page: '/blog' },
                { icon: 'person', title: 'Join the Team', page: '/join' }
            ],
            isScript: false
        };
    },
    methods: {
        changePage(page) {
            this.$router.push('/' + page);
        }
    },
    mounted() {
        this.isScript = true;
        window.addEventListener('click', () => {
            this.drawer = false;
        });
    }
};



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar.js